<template>
    <app-layout>
        <common-content-spacer height="medium">
            <common-breadcrumbs :breadcrumbs="pageBreadcrumbs"></common-breadcrumbs>
            <common-content-spacer height="large">
                <patient-name :physician="patientDetails" @toggle="toggleModal"></patient-name>
            </common-content-spacer>
            <common-page-split spacing="medium" class="doc-layout">
                <template #aside>
                    <common-page-header :heading="pageTitle" size="small"></common-page-header>
                    <patient-sidebar
                        :physician="patientDetails"
                        :isAccidentIntakeActive="isAccidentIntakeOpen"
                        @toggle="toggleModal"
                    ></patient-sidebar>
                </template>
                <template #main>
                    <common-content-spacer height="large">
                        <div v-if="isAccidentIntakeOpen" class="accident-intake-panel">
                            <accident-intake-wizard
                                :patientDetails="patientDetails"
                                :patientId="$route.params.id"
                                :authenticated="true"
                            ></accident-intake-wizard>
                        </div>
                        <patient-detail-form
                            v-else
                            :physician="{
                                PatientMessage: isPatientMessageModalOpen,
                                CheckPassword: isCheckPasswordModalOpen,
                                DeletePatient: isDeletePatientModalOpen,
                                DirectReferral: isDirectReferralModalOpen,
                            }"
                            :patientDetails="patientDetails"
                            @toggle="toggleModal"
                            @updateDetailPage="loadData"
                        ></patient-detail-form>
                    </common-content-spacer>
                </template>
            </common-page-split>
        </common-content-spacer>
    </app-layout>
</template>
<script>
    import AppLayout from 'components/layouts/AppLayout'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import PatientDetailForm from 'components/forms/patient/PatientDetailForm'
    import PatientSidebar from 'components/forms/patient/PatientSidebar'
    import PatientName from 'components/forms/patient/PatientName'
    import AccidentIntakeWizard from 'components/forms/AccidentIntakeWizard'
    import PatientAPI from 'api/PatientAPI'
    export default {
        mixins: [PageWithDataMixin],
        components: {
            AppLayout,
            PatientDetailForm,
            PatientSidebar,
            PatientName,
            AccidentIntakeWizard,
        },

        data() {
            return {
                isPatientMessageModalOpen: false,
                isCheckPasswordModalOpen: false,
                isDeletePatientModalOpen: false,
                isDirectReferralModalOpen: false,
                isAccidentIntakeOpen: false,
                patientDetails: {},
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.patient.details.titles.patient_title', { patientTitle: 'Patient' })
            },

            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.patient.details.breadcrumbs.patient'),
                        route: { name: 'practice.profile' },
                    },
                    {
                        label: this.$t('pages.patient.details.breadcrumbs.patient_details'),
                    },
                ]
            },
        },
        methods: {
            toggleModal(name) {
                switch (name) {
                    case 'toggle-patient-message-modal':
                        this.isAccidentIntakeOpen = false
                        this.isPatientMessageModalOpen = !this.isPatientMessageModalOpen
                        break
                    case 'toggle-check-password-modal':
                        this.isAccidentIntakeOpen = false
                        this.isCheckPasswordModalOpen = !this.isCheckPasswordModalOpen
                        break
                    case 'toggle-delete-patient-modal':
                        this.isAccidentIntakeOpen = false
                        this.isDeletePatientModalOpen = !this.isDeletePatientModalOpen
                        break
                    case 'toggle-direct-referral-modal':
                        this.isAccidentIntakeOpen = false
                        this.isDirectReferralModalOpen = !this.isDirectReferralModalOpen
                        break
                    case 'toggle-accident-intake':
                        this.isAccidentIntakeOpen = true
                        break
                    case 'toggle-patient-record-modal':
                        this.isAccidentIntakeOpen = false
                        break
                }
            },
            loadData() {
                const patientId = this.$route.params.id
                PatientAPI.getPatientDetails(patientId, this.$auth.getUser().id)
                    .then((res) => {
                        this.patientDetails = res
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },
        mounted() {
            this.loadData()
        },
    }
</script>
<style>
    .bg input {
        flex: 1;
        padding: 8px 29px;
        border-radius: 6px;
        border: 1px solid #f5f5f5;
        font-size: 12px;
        background-color: #f5f5f5;
        height: 51px;
        width: 100%;
    }
    .bg i {
        position: absolute;
        top: 15px;
        left: 7px;
    }
    .bg {
        display: flex;
        gap: 10px;
        position: relative;
        width: 100%;
    }
    .patient-detail-form-text input:disabled {
        border: 0 !important;
        opacity: 1 !important;
        background-color: transparent !important;
        height: 8px;
        color: oklch(0.21 0.034 264.665);
    }
    .patient-detail-form-text.form-field--is-disabled .form-field__label {
        opacity: 1 !important;
        font-weight: 500 !important;
        padding-left: 14px !important;
        color: oklch(0.446 0.03 256.802);
        margin-bottom: 1px;
    }
    .patient-detail-form-text .form-phone-input__area-code.form-phone-input__area-code--disabled {
        opacity: 1 !important;
        border: 0 !important;
        width: 20px !important;
        padding-left: 15px;
        position: relative;
        top: -11px;
    }
    .doc-layout {
        border: 0 !important;

        .page-split__aside {
            width: unset !important;
        }
        background: transparent !important;
    }
    .headings {
        color: oklch(0.145 0 0);
        font-size: 20px;
        font-weight: 500;
        padding: 12px 12px 0 12px;
    }
    .accident-intake-panel {
        background: #fff;
        border: 1px solid #eceff3;
        border-radius: 12px;
        padding: 24px;
    }
</style>
